const Pricing = () => {
  const features = [
    'Unlimited users',
    'Fair use screenshot storage',
    'Self-hosted deployment with premium support',
    'ActivityWatch integration',
    'Advanced reporting tools',
    'Privacy-focused design',
    'Customizable workflows',
    'Docker deployment'
  ]

  return (
    <section className="py-20" style={{ backgroundColor: 'var(--bg-main)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-4xl font-bold mb-4"
            style={{ color: 'var(--text-main)' }}
          >
            Simple, Transparent Pricing
          </h2>
          <p
            className="text-xl max-w-2xl mx-auto"
            style={{ color: 'var(--text-main2)' }}
          >
            One price, all features. No hidden costs, no per-user fees.
          </p>
        </div>

        <div className="max-w-md mx-auto">
          <div className="card card-feature">
            <div className="text-center">
              <h3
                className="text-2xl font-bold mb-2"
                style={{ color: 'var(--text-main)' }}
              >
                TrakStr Pro
              </h3>
              <div className="mb-6">
                <span
                  className="text-5xl font-bold"
                  style={{ color: 'var(--link-main)' }}
                >
                  210€
                </span>
                <span
                  className="text-xl ml-2"
                  style={{ color: 'var(--text-main2)' }}
                >
                  /year
                </span>
              </div>

              <p
                className="text-lg mb-8"
                style={{ color: 'var(--text-main2)' }}
              >
                Everything you need for time tracking
              </p>

              <ul className="text-left space-y-3 mb-8">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-center">
                    <svg
                      className="w-5 h-5 mr-3 flex-shrink-0"
                      style={{ color: 'var(--success)' }}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span style={{ color: 'var(--text-main)' }}>{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="space-y-4">
                <button className="btn btn-primary btn-lg btn-full">
                  Get Started Now
                </button>
              </div>

              <p
                className="text-sm mt-6"
                style={{ color: 'var(--text-main2)' }}
              >
                Cancel anytime. No long-term contracts.
              </p>
            </div>
          </div>
        </div>

        {/* Additional info section */}
        <div className="mt-16 text-center">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="card p-6">
              <div
                className="w-12 h-12 mx-auto mb-4"
                style={{ color: 'var(--link-main)' }}
              >
                <svg fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h4
                className="text-lg font-semibold mb-2"
                style={{ color: 'var(--text-main)' }}
              >
                Self-Hosted
              </h4>
              <p style={{ color: 'var(--text-main2)' }}>
                Your data stays on your servers. Complete privacy and control.
              </p>
            </div>

            <div className="card p-6">
              <div
                className="w-12 h-12 mx-auto mb-4"
                style={{ color: 'var(--link-main)' }}
              >
                <svg fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h4
                className="text-lg font-semibold mb-2"
                style={{ color: 'var(--text-main)' }}
              >
                No Limits
              </h4>
              <p style={{ color: 'var(--text-main2)' }}>
                Unlimited users, unlimited projects, unlimited time tracking.
              </p>
            </div>

            <div className="card p-6">
              <div
                className="w-12 h-12 mx-auto mb-4"
                style={{ color: 'var(--link-main)' }}
              >
                <svg fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h4
                className="text-lg font-semibold mb-2"
                style={{ color: 'var(--text-main)' }}
              >
                Fair Use
              </h4>
              <p style={{ color: 'var(--text-main2)' }}>
                Reasonable screenshot storage limits with clear guidelines.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Pricing
